// Newsletter divider block.
//
// Atom node — no content. Renders as `<hr>` with data-* attrs that encode
// style + color, so the email renderer can later read them off the DOM/JSON
// and emit an email-safe `<table>`-based separator.

import { Node, mergeAttributes } from "@tiptap/core"

import { idAttributeSpec } from "./attributes"
import { insertBlockAfter } from "./commands"

const VALID_STYLES = ["solid", "dashed", "thick"]

export const NewsletterDivider = Node.create({
  name: "newsletterDivider",
  group: "newsletterBlock",
  atom: true,
  selectable: true,
  draggable: true,

  addOptions() {
    return { HTMLAttributes: {} }
  },

  addAttributes() {
    return {
      id: idAttributeSpec,
      dividerStyle: {
        default: "solid",
        parseHTML: (el) => {
          const value = el.getAttribute("data-divider-style")
          return VALID_STYLES.includes(value) ? value : "solid"
        },
        renderHTML: (attrs) => ({ "data-divider-style": attrs.dividerStyle }),
      },
      color: {
        default: "#d1d5db",
        parseHTML: (el) => el.getAttribute("data-color") || "#d1d5db",
        renderHTML: (attrs) => ({ "data-color": attrs.color }),
      },
    }
  },

  parseHTML() {
    return [{ tag: "hr" }]
  },

  renderHTML({ HTMLAttributes }) {
    return ["hr", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)]
  },

  addCommands() {
    return {
      insertNewsletterDivider:
        (attrs = {}) =>
        (props) =>
          insertBlockAfter(this.name, attrs)(props),
    }
  },
})
